import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import room1 from "../../../../assets/barbiere/1.JPG";

type Props = {
  src?: string;
  width?: string;
  text?: string;
  fontSize?: string;
  description?: string;
  isLink?: boolean;
  isHeading?: boolean;
  noHover?: boolean;
};

const BrochureImage = ({
  src,
  width,
  text,
  description,
  fontSize,
  isLink,
  isHeading,
  noHover,
}: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(min-width: 768px)");
  return (
    <Box
      width={width || "90vw"}
      height={isTablet && !isHeading ? "55vh" : "30vh"}
      position="relative"
      boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
    >
      <Box
        style={{
          background: `url("${src || room1}")`,
          backgroundPosition: isMobile ? "center" : "bottom",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bgcolor="rgba(0, 0, 0, 0.424)"
          sx={{
            // borderRadius: isMobile ? "10px" : undefined,
            transition: "background-color 0.3s",
            "&:hover": {
              backgroundColor:
                noHover || !isHeading ? undefined : "rgba(0, 0, 0, 0.0)",
            },
          }}
        />
        <Typography
          variant="h3"
          color="primary"
          style={{
            zIndex: 1000,
            fontSize: fontSize || undefined,
            textAlign: "center",
            width: "100%",
            padding: "5px 60px",
            color: "white",
            borderRadius: "5px",
            textTransform: "none",
            letterSpacing: isMobile ? undefined : "3px",
          }}
        >
          {text || "ROOMS"}
        </Typography>
        <Typography
          color="primary"
          variant="h5"
          style={{
            zIndex: 1000,

            fontStyle: "italic",
            textAlign: "center",
            width: "100%",
            padding: "0px 10px",
            color: "white",
            borderRadius: "5px",
            textTransform: "none",
          }}
        >
          {description || ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default BrochureImage;
